var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrossThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m8.666 7.914 3.646 3.646a.5.5 0 1 1-.707.708L7.958 8.62l-3.646 3.647a.5.5 0 1 1-.707-.708L7.25 7.914 3.605 4.268a.5.5 0 0 1 .707-.707l3.646 3.646 3.647-3.646a.5.5 0 1 1 .707.707z",
  clipRule: "evenodd"
})));
export default SvgCrossThin;